/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandGoogleFit = createReactComponent("outline", "brand-google-fit", "IconBrandGoogleFit", [["path", { "d": "M12 8.866l-2.733 -2.734a3.866 3.866 0 0 0 -5.467 5.467l2.733 2.734l5.467 5.467l8.202 -8.201a3.866 3.866 0 0 0 -5.469 -5.466l-8.201 8.2", "key": "svg-0" }]]);

export { IconBrandGoogleFit as default };
//# sourceMappingURL=IconBrandGoogleFit.mjs.map
